import { render, staticRenderFns } from "./KnFormGrade.vue?vue&type=template&id=6cfe1e25"
import script from "./KnFormGrade.js?vue&type=script&lang=js&external"
export * from "./KnFormGrade.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports